import { render, staticRenderFns } from "./disable-blue-ticks-in-gb-whatsapp.vue?vue&type=template&id=3481975c"
import script from "./disable-blue-ticks-in-gb-whatsapp.vue?vue&type=script&lang=js"
export * from "./disable-blue-ticks-in-gb-whatsapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports